import React from 'react';
import Navbar from '../../components/Navbar/Navbar';

const Contact = () => {
    return (
        <div>
            <Navbar></Navbar>
            <h3>Hello from contact</h3>
        </div>
    );
};

export default Contact;